import React from "react";
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Divider from '@material-ui/core/Divider';
import SvgIcon from '@material-ui/core/SvgIcon';
import InputAdornment from '@material-ui/core/InputAdornment';

// Material UI Icons
import GoBackIcon from '@material-ui/icons/KeyboardArrowLeftRounded';
import IconChevronRight from '@material-ui/icons/ChevronRightRounded';
import VideocamIcon from '@material-ui/icons/VideocamRounded';
import HomeIcon from '@material-ui/icons/HomeRounded';
import GroupIcon from '@material-ui/icons/GroupRounded';

// Moment
import moment from 'moment';

// Components
import ImageGridList from '../UI/DisplayImages/ImageGridList';
import ChangeSaveButton from '../UI/Buttons/ChangeSaveButton';
import OutlinedButton from '../UI/Buttons/OutlinedButton';
import DeleteButton from '../UI/Buttons/DeleteButton';
import HistoryList from '../HistoryList/HistoryList';
import DropDownMenu from '../Inventory/DropDownMenu';
import * as actions from '../../store/actions/index';
import { getCategoryFromCodeName } from '../Inventory/Utilities/categoriesUtil';
import { getSpeciesListBasedOnCategory } from '../Inventory/Utilities/speciesUtil';
import UpgradeMenu from '../UI/Menus/UIElements/UpgradeMenu';

const categories = require('../../components/Inventory/Utilities/catagories');

// Custom icons
function ForestOtherIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M7.59371481,13.6108778 L10.7900335,16.7723051 C11.5716412,17.5453807 12.8306782,17.542686 13.6089696,16.7662718 L16.7794786,13.60341 C17.5614697,12.8233051 17.5629987,11.556976 16.7828937,10.7749849 C16.7805389,10.7726244 16.7781782,10.7702698 16.7758116,10.7679211 L13.5640433,7.58043128 C12.7800371,6.80235156 11.5137162,6.80715593 10.7356365,7.59116213 C10.7348897,7.59191467 10.7341434,7.5926678 10.7333978,7.59342153 L7.57819262,10.7824932 C6.80136073,11.5677359 6.80817899,12.8340475 7.59342162,13.6108794 C7.59347075,13.610928 7.59351988,13.6109766 7.59356902,13.6110252 Z"></path>
        </SvgIcon>
    );
}

function HuntingGroundIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.56563145,8.57142857 L18.8692503,8.57142857 C19.6269052,8.57142857 20.0057326,8.94491465 20.0057326,9.69188679 C20.0057326,10.4388589 19.6269052,10.8287764 18.8692503,10.8616392 C13.5345818,10.8616392 10.8672475,10.8616392 10.8672475,10.8616392 C10.8672475,10.8616392 10.8672475,11.9666997 10.8672475,11.9666997 C10.8672475,12.3220337 10.2934419,12.5722318 10.2934419,12.5722318 C10.2934419,12.5722318 6.88048912,14.5342905 6.88048912,14.5342905 C6.88048912,14.5342905 6.26032966,14.8318609 5.71883728,14.8318609 C5.71883728,14.8318609 5.71883728,14.8318609 4.56563145,14.8318609 C4.54444355,14.8318609 3.42857143,14.8318609 3.42857143,13.6889063 C3.42857143,13.6889063 3.42857143,10.4568524 3.42857143,9.69188679 C3.42857143,8.94491465 3.80759144,8.57142857 4.56563145,8.57142857 Z M6.28650972,16.5721576 L17.1522098,16.5721576 C17.9390075,16.5716716 18.3324063,16.9472 18.3324063,17.6987428 C18.3324063,18.4502856 17.9390075,18.826057 17.1522098,18.826057 L6.28650972,18.826057 C5.52407467,18.826057 5.14285714,18.4455379 5.14285714,17.6844996 C5.14285714,16.9234613 5.52407467,16.5526806 6.28650972,16.5721576 Z M9.6993099,5.14285714 L14.8409579,5.14285714 C15.5827236,5.14285714 15.9536064,5.53008376 15.9536064,6.30453701 C15.9536064,7.07899025 15.5827236,7.45519473 14.8409579,7.43315046 L9.6993099,7.43315046 C8.94738902,7.45519473 8.57142857,7.07899025 8.57142857,6.30453701 C8.57142857,5.53008376 8.94738902,5.14285714 9.6993099,5.14285714 Z"></path>
        </SvgIcon>
    );
}

function HuntingLatterIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.56622579,6.83832014 L18.8698446,6.83832014 C19.6274995,6.83832014 20.006327,7.21180621 20.006327,7.95877836 C20.006327,8.70575051 19.6274995,9.09566798 18.8698446,9.12853076 C13.5351761,9.12853076 10.8678419,9.12853076 10.8678419,9.12853076 C10.8678419,9.12853076 10.8678419,10.2335912 10.8678419,10.2335912 C10.8678419,10.5889252 10.2940363,10.8391234 10.2940363,10.8391234 C10.2940363,10.8391234 6.88108346,12.8011821 6.88108346,12.8011821 C6.88108346,12.8011821 6.26092399,13.0987525 5.71943161,13.0987525 C5.71943161,13.0987525 5.71943161,13.0987525 4.56622579,13.0987525 C4.54503788,13.0987525 3.42916576,13.0987525 3.42916576,11.9557979 C3.42916576,11.9557979 3.42916576,8.72374392 3.42916576,7.95877836 C3.42916576,7.21180621 3.80818577,6.83832014 4.56622579,6.83832014 Z M6.28710406,14.8390492 L13.7269857,14.8390492 C14.3892054,14.8324707 14.9571208,15.1712684 15.430732,15.8554423 C15.430732,15.8554423 17.9816617,20.4733615 17.9816617,20.4733615 C17.9816617,20.4733615 18.5801638,21.3141647 17.5950149,21.9176007 C16.6098661,22.5210367 16.1389224,21.7015936 16.1389224,21.7015936 C16.1389224,21.7015936 15.2882114,20.1653786 13.5867894,17.0929486 L6.28710406,17.0929486 C5.52466901,17.0929486 5.14345148,16.7124294 5.14345148,15.9513911 C5.14345148,15.1903528 5.52466901,14.8195722 6.28710406,14.8390492 Z M9.12847567,3.40974871 L14.2701237,3.40974871 C15.0118893,3.40974871 15.3827722,3.79697533 15.3827722,4.57142857 C15.3827722,5.34588181 15.0118893,5.7220863 14.2701237,5.70004202 L9.12847567,5.70004202 C8.37655478,5.7220863 8.00059434,5.34588181 8.00059434,4.57142857 C8.00059434,3.79697533 8.37655478,3.40974871 9.12847567,3.40974871 Z"></path>
        </SvgIcon>
    );
}

function HuntingTowerIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.32405205,4.44592923 L18.4406788,4.42857143 C19.1983337,4.42857143 19.5771612,4.8020575 19.5771612,5.54902965 C19.5771612,6.2960018 19.1983337,6.68591927 18.4406788,6.71878205 C13.1060103,6.71878205 10.4386761,6.71878205 10.4386761,6.71878205 C10.4386761,6.71878205 10.4386761,7.82384253 10.4386761,7.82384253 C10.4386761,8.17917654 9.86487052,8.4293747 9.86487052,8.4293747 C9.86487052,8.4293747 6.45191769,10.3914334 6.45191769,10.3914334 C6.45191769,10.3914334 5.83175823,10.6890038 5.29026585,10.6890038 C5.29026585,10.6890038 5.29026585,10.6890038 4.13706002,10.6890038 C4.11587212,10.6890038 3,10.6890038 3,9.54604919 C3,9.54604919 3,6.31399521 3,5.54902965 C3,4.8020575 3.44135068,4.43435736 4.32405205,4.44592923 Z M3.60378196,21.4993764 C5.80964618,15.6669168 6.91257829,12.750687 6.91257829,12.750687 C7.25852182,11.8564168 8.01249648,11.8570252 8.01249648,11.8571459 C8.01249648,11.8576319 10.2934909,11.8576319 14.8554797,11.8571459 C15.4092949,11.8576319 15.8299696,12.1554789 16.1175039,12.750687 C16.1175039,12.750687 19.3083114,21.4993764 19.3083114,21.4993764 C19.3083114,21.4993764 19.6041658,22.2835836 18.6281929,22.7281156 C17.65222,23.1726477 17.2552223,22.177727 17.2552223,22.177727 C17.2552223,22.177727 16.7153786,20.730806 15.6356912,17.8369639 C10.1395092,17.8369639 7.39141818,17.8369639 7.39141818,17.8369639 C7.39141818,17.8369639 6.83743107,19.283885 5.72945686,22.177727 C5.35757054,22.7849305 4.8794266,22.9683933 4.29502504,22.7281156 C3.71062348,22.4878379 3.48020912,22.0782582 3.60378196,21.4993764 Z M8.6993099,1 L13.8409579,1 C14.5827236,1 14.9536064,1.38722662 14.9536064,2.16167986 C14.9536064,2.9361331 14.5827236,3.31233759 13.8409579,3.29029331 L8.6993099,3.29029331 C7.94738902,3.31233759 7.57142857,2.9361331 7.57142857,2.16167986 C7.57142857,1.38722662 7.94738902,1 8.6993099,1 Z"></path>
        </SvgIcon>
    );
}

function HuntingStoneIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M11.7250429,19.6110362 C11.5597193,20.5160635 9.67235307,21.2297628 7.36840305,21.2297628 C4.95580067,21.2297628 3,20.4471613 3,19.4817734 L3,15.4805544 L3.00312163,15.4805544 C3.07499452,14.7139736 4.38054411,14.0736827 6.14838613,13.8683461 C5.73247078,14.1633723 5.1614368,14.8296609 5.1614368,15.6495325 C5.1614368,17.0783747 5.48941577,18.1578716 5.8854236,18.918536 C6.08275177,19.2975702 6.55967025,19.8088835 6.99545598,19.9627414 C7.32285296,20.0783317 8.34235154,19.9620165 9.45571219,19.8558551 C10.2175889,19.7832085 10.9740324,19.7016022 11.7250429,19.6110362 Z M11.2234423,4.56277081 C10.2781203,4.08716858 11.118256,2.82803222 11.7368061,3.01968749 C11.801118,3.02048809 13.3259367,3.5348492 16.3112622,4.56277081 L17.8036974,10.031899 C18.965702,9.95390313 19.5467043,9.91490521 19.5467043,9.91490521 C21.101504,9.67600096 21.2629781,10.7217946 20.7110652,11.7368509 C20.7110652,11.7368509 20.5790002,11.9178827 20.3148701,12.2799464 C19.9041588,12.8429405 18.5696228,14.672293 16.3112622,17.7680041 C10.6911473,18.3528711 7.88108986,18.6453046 7.88108986,18.6453046 C7.08405676,18.6353826 6.95996194,17.8192933 6.74086735,16.8513807 C6.52177277,15.8834681 6.39234746,15.4990401 7.04879577,14.968409 C7.10764254,14.920841 8.71023458,13.8666594 11.8565719,11.8058643 L15.0111189,10.7123164 L14.6674399,8.1171911 C13.2583842,8.87078437 12.5538563,9.24758101 12.5538563,9.24758101 C11.8124023,9.71854298 10.9485983,8.55027678 11.8180484,7.79960117 C11.8180484,7.79960117 12.4976732,7.20541606 13.8569228,6.01704583 C12.2038637,5.12167946 11.3260369,4.63692112 11.2234423,4.56277081 Z"></path>
        </SvgIcon>
    );
}

function HuntingBucketIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8.84016512,12.0681883 C7.21576527,13.1603537 6.34685848,13.7415479 6.23344474,13.8117706 C5.81546986,14.0705696 5.1614368,14.772098 5.1614368,15.6495325 C5.1614368,17.0783747 5.48941577,18.1578716 5.8854236,18.918536 C6.08275177,19.2975702 6.55967025,19.8088835 6.99545598,19.9627414 C7.32285296,20.0783317 8.34235154,19.9620165 9.45571219,19.8558551 C10.2175889,19.7832085 10.9740324,19.7016022 11.7250429,19.6110362 C11.5597193,20.5160635 9.67235307,21.2297628 7.36840305,21.2297628 C4.95580067,21.2297628 3,20.4471613 3,19.4817734 L3,10.4218865 C3,11.3872744 4.95580067,12.1698759 7.36840305,12.1698759 C7.88482017,12.1698759 8.38030785,12.1340192 8.84016512,12.0681883 Z M7.36840305,10.9358163 C6.09114297,10.9358163 5.05571908,10.590675 5.05571908,10.1649216 C5.05571908,9.73916823 6.09114297,9.39402694 7.36840305,9.39402694 C8.64566314,9.39402694 9.68108702,9.73916823 9.68108702,10.1649216 C9.68108702,10.590675 8.64566314,10.9358163 7.36840305,10.9358163 Z M11.2234423,4.56277081 C10.2781203,4.08716858 11.118256,2.82803222 11.7368061,3.01968749 C11.801118,3.02048809 13.3259367,3.5348492 16.3112622,4.56277081 L17.8036974,10.031899 C18.965702,9.95390313 19.5467043,9.91490521 19.5467043,9.91490521 C21.101504,9.67600096 21.2629781,10.7217946 20.7110652,11.7368509 C20.7110652,11.7368509 20.5790002,11.9178827 20.3148701,12.2799464 C19.9041588,12.8429405 18.5696228,14.672293 16.3112622,17.7680041 C10.6911473,18.3528711 7.88108986,18.6453046 7.88108986,18.6453046 C7.08405676,18.6353826 6.95996194,17.8192933 6.74086735,16.8513807 C6.52177277,15.8834681 6.39234746,15.4990401 7.04879577,14.968409 C7.10764254,14.920841 8.71023458,13.8666594 11.8565719,11.8058643 L15.0111189,10.7123164 L14.6674399,8.1171911 C13.2583842,8.87078437 12.5538563,9.24758101 12.5538563,9.24758101 C11.8124023,9.71854298 10.9485983,8.55027678 11.8180484,7.79960117 C11.8180484,7.79960117 12.4976732,7.20541606 13.8569228,6.01704583 C12.2038637,5.12167946 11.3260369,4.63692112 11.2234423,4.56277081 Z"></path>
        </SvgIcon>
    );
}

function HuntingBoxIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M11.8603033,9.47195103 L11.257845,9.87858164 C10.9931076,10.0439188 10.7392082,10.2024568 10.4961469,10.3541959 C10.3127103,10.1368636 10.0382866,9.99882433 9.73162222,9.99882433 L5.78422051,9.99882433 C5.23193576,9.99882433 4.78422051,10.4465396 4.78422051,10.9988243 L4.78422051,18.3767563 C4.78422051,18.929041 5.23193576,19.3767563 5.78422051,19.3767563 L9.73162222,19.3767563 C10.155023,19.3767563 10.5169652,19.1136211 10.6628365,18.741963 C11.2688236,18.6835216 11.87153,18.6200623 12.4709559,18.5515849 C12.2247683,19.9606384 10.9953837,21.0316855 9.51584273,21.0316855 L6,21.0316855 C4.34314575,21.0316855 3,19.6885397 3,18.0316855 L3,11.3438952 C3,9.68704091 4.34314575,8.34389516 6,8.34389516 L9.51584273,8.34389516 C10.4646433,8.34389516 11.3105694,8.78435303 11.8603033,9.47195103 Z M11.2234423,3.55632382 C10.2781203,3.08268362 11.118256,1.82874165 11.7368061,2.01960627 C11.801118,2.02040357 13.3259367,2.53264275 16.3112622,3.55632382 L17.8036974,9.00288987 C18.965702,8.9252158 19.5467043,8.88637876 19.5467043,8.88637876 C21.101504,8.64846008 21.2629781,9.68993944 20.7110652,10.7008082 C20.7110652,10.7008082 20.5790002,10.8810933 20.3148701,11.2416633 C19.9041588,11.8023348 18.5696228,13.6241407 16.3112622,16.7070809 C10.6911473,17.2895351 7.88108986,17.5807622 7.88108986,17.5807622 C7.08405676,17.5708811 6.95996194,16.7581584 6.74086735,15.7942388 C6.52177277,14.8303192 6.39234746,14.4474771 7.04879577,13.919035 C7.10764254,13.8716633 8.71023458,12.8218306 11.8565719,10.769537 L15.0111189,9.68050037 L14.6674399,7.09608086 C13.2583842,7.8465653 12.5538563,8.22180751 12.5538563,8.22180751 C11.8124023,8.6908266 10.9485983,7.52737991 11.8180484,6.77980111 C11.8180484,6.77980111 12.4976732,6.18806722 13.8569228,5.00459944 C12.2038637,4.11292677 11.3260369,3.63016823 11.2234423,3.55632382 Z"></path>
        </SvgIcon>
    );
}

function LeveYngleRasteIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.5,12 C3.11928813,12 2,10.8807119 2,9.5 C2,8.11928813 3.11928813,7 4.5,7 C5.88071187,7 7,8.11928813 7,9.5 C7,10.8807119 5.88071187,12 4.5,12 Z M9,8 C7.61928813,8 6.5,6.88071187 6.5,5.5 C6.5,4.11928813 7.61928813,3 9,3 C10.3807119,3 11.5,4.11928813 11.5,5.5 C11.5,6.88071187 10.3807119,8 9,8 Z M15,8 C13.6192881,8 12.5,6.88071187 12.5,5.5 C12.5,4.11928813 13.6192881,3 15,3 C16.3807119,3 17.5,4.11928813 17.5,5.5 C17.5,6.88071187 16.3807119,8 15,8 Z M19.5,12 C18.1192881,12 17,10.8807119 17,9.5 C17,8.11928813 18.1192881,7 19.5,7 C20.8807119,7 22,8.11928813 22,9.5 C22,10.8807119 20.8807119,12 19.5,12 Z M17.34,14.86 C18.65,16.17 20.26,17.62 19.95,19.66 C19.66,20.67 18.93,21.69 17.62,21.98 C16.89,22.12 14.56,21.54 12.08,21.54 L11.9,21.54 C9.42,21.54 7.09,22.13 6.36,21.98 C5.05,21.69 4.32,20.68 4.03,19.66 C3.73,17.63 5.34,16.18 6.65,14.87 C7.53,13.85 8.26,12.98 9.13,11.96 C9.6,11.42 10.18,10.88 10.88,10.64 C10.99,10.6 11.1,10.57 11.21,10.55 C11.47,10.5 11.74,10.5 12,10.5 C12.26,10.5 12.53,10.5 12.78,10.54 C12.89,10.56 13,10.59 13.11,10.63 C13.81,10.87 14.4,11.41 14.86,11.95 C15.74,12.97 16.47,13.84 17.34,14.86 Z"></path>
        </SvgIcon>
    );
}

function NaturIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M21.94,4.88 C22.12,5.44 21.89,6.05 21.38,6.36 L20.51,6.88 L20.9,8.12 C21.13,8.7 20.95,9.37 20.45,9.74 C20.22,9.91 19.94,10 19.67,10 C19.36,10 19.06,9.89 18.81,9.68 L18,8.98 L17.19,9.68 C16.94,9.89 16.64,10 16.33,10 C16.06,10 15.78,9.91 15.55,9.74 C15.06,9.37 14.87,8.7 15.1,8.12 L15.5,6.88 L14.63,6.36 C14.11,6.05 13.88,5.44 14.07,4.88 C14.25,4.35 14.76,4 15.33,4 C15.36,4 15.39,4 15.42,4 L16.4,4 L16.71,3.04 C16.85,2.43 17.39,2 18,2 C18.61,2 19.15,2.43 19.29,3.03 L19.6,4 L20.59,4 C20.62,4 20.65,4 20.68,4 C21.25,4 21.76,4.35 21.94,4.88 Z M18,7 C18.55,7 19,6.55 19,6 C19,5.45 18.55,5 18,5 C17.45,5 17,5.45 17,6 C17,6.55 17.45,7 18,7 Z M15.5,12 C15.78,12 16,12.22 16.01,12.51 C16.01,12.79 15.79,13.01 15.51,13.01 L14.63,13.01 C14.73,14.14 14.36,15.31 13.49,16.18 C13.32,16.34 13.14,16.48 12.96,16.61 L13.48,17.98 C14.04,19.56 13.22,21.28 11.66,21.83 C11.33,21.94 10.99,22 10.65,22 C10.21,22 9.78,21.9 9.36,21.7 C8.88,21.47 8.49,21.12 8.2,20.7 C6.86,21.08 5.35,20.76 4.29,19.7 C3.23,18.64 2.91,17.14 3.29,15.79 C2.87,15.5 2.52,15.11 2.29,14.63 C1.94,13.91 1.9,13.09 2.17,12.34 C2.72,10.79 4.44,9.97 6,10.52 L7.4,11.05 C7.53,10.86 7.67,10.68 7.83,10.52 C8.61,9.74 9.64,9.35 10.66,9.35 C10.77,9.35 10.89,9.37 11,9.38 L11,8.5 C11,8.22 11.22,8 11.5,8 C11.78,8 12,8.22 12,8.5 L12,9.59 C12.54,9.78 13.04,10.07 13.48,10.51 C13.92,10.95 14.22,11.46 14.41,12 L15.5,12 Z M4.67,14.29 C5.85,14.71 7.33,14.2 8.48,13.6 L5.32,12.41 C4.82,12.23 4.25,12.5 4.06,13.02 C3.97,13.27 3.98,13.54 4.1,13.78 C4.22,14.02 4.42,14.2 4.67,14.29 Z M10.99,19.94 C11.51,19.76 11.78,19.18 11.6,18.66 L10.42,15.53 C9.81,16.68 9.3,18.15 9.72,19.33 C9.81,19.58 9.99,19.79 10.23,19.9 C10.47,20.02 10.74,20.03 10.99,19.94 Z M12.2,14.6 C12.84,13.81 12.8,12.66 12.07,11.93 C11.7,11.55 11.19,11.34 10.66,11.34 C10.19,11.34 9.76,11.51 9.4,11.8 L11,12.4 C11.01,12.41 11.02,12.42 11.03,12.42 C11.08,12.43 11.11,12.46 11.15,12.48 C11.19,12.5 11.23,12.52 11.26,12.55 C11.29,12.58 11.32,12.61 11.35,12.64 C11.38,12.67 11.41,12.7 11.44,12.73 C11.47,12.77 11.49,12.8 11.51,12.84 C11.53,12.88 11.55,12.92 11.57,12.96 C11.58,12.97 11.59,12.98 11.59,12.99 L12.2,14.6 Z"></path>
        </SvgIcon>
    );
}

function FortidKulturIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M13.2,7.07 L10.25,11 L12.5,14 C12.83,14.44 12.74,15.07 12.3,15.4 C11.86,15.73 11.23,15.65 10.9,15.2 C9.85,13.8 8.59,12.13 7.8,11.06 C7.4,10.53 6.6,10.53 6.2,11.06 L2.2,16.39 C1.71,17.06 2.18,18 3,18 L21,18 C21.82,18 22.29,17.06 21.8,16.4 L14.8,7.07 C14.4,6.53 13.6,6.53 13.2,7.07 Z"></path>
        </SvgIcon>
    );
}

function StoreTraerIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M5.25605856,11 C5.09023133,10.5308316 5,10.0259531 5,9.5 C5,7.74169383 6.00844513,6.21892264 7.4785109,5.4785109 C8.21892264,4.00844513 9.74169383,3 11.5,3 C13.089617,3 14.4867248,3.82422967 15.2872671,5.0686327 C17.3971873,5.4409281 19,7.28328557 19,9.5 C19,10.0259531 18.9097687,10.5308316 18.7439414,11 C18.9097687,11.4691684 19,11.9740469 19,12.5 C19,14.9852814 16.9852814,17 14.5,17 C14.330932,17 14.1640416,16.9906763 13.999815,16.9725152 C13.9999382,16.9816621 14,16.9908238 14,17 L14,20 C14,21.1045695 13.1045695,22 12,22 C10.8954305,22 10,21.1045695 10,20 L10,17 C10,16.9908238 10.0000618,16.9816621 10.000185,16.9725152 C9.83595841,16.9906763 9.66906803,17 9.5,17 C7.01471863,17 5,14.9852814 5,12.5 C5,11.9740469 5.09023133,11.4691684 5.25605856,11 Z"></path>
        </SvgIcon>
    );
}

function SaerligeTraerIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M5.25605856,11 C5.09023133,10.5308316 5,10.0259531 5,9.5 C5,7.74169383 6.00844513,6.21892264 7.4785109,5.4785109 C8.21892264,4.00844513 9.74169383,3 11.5,3 C13.089617,3 14.4867248,3.82422967 15.2872671,5.0686327 C17.3971873,5.4409281 19,7.28328557 19,9.5 C19,10.0259531 18.9097687,10.5308316 18.7439414,11 C18.9097687,11.4691684 19,11.9740469 19,12.5 C19,14.9852814 16.9852814,17 14.5,17 C14.330932,17 14.1640416,16.9906763 13.999815,16.9725152 C13.9999382,16.9816621 14,16.9908238 14,17 L14,20 C14,21.1045695 13.1045695,22 12,22 C10.8954305,22 10,21.1045695 10,20 L10,17 C10,16.9908238 10.0000618,16.9816621 10.000185,16.9725152 C9.83595841,16.9906763 9.66906803,17 9.5,17 C7.01471863,17 5,14.9852814 5,12.5 C5,11.9740469 5.09023133,11.4691684 5.25605856,11 Z M12,15 C12.5522847,15 13,14.5522847 13,14 C13,13.4477153 12.5522847,13 12,13 C11.4477153,13 11,13.4477153 11,14 C11,14.5522847 11.4477153,15 12,15 Z M12,6 C11.4477153,6 11,6.44771525 11,7 L11,11 C11,11.5522847 11.4477153,12 12,12 C12.5522847,12 13,11.5522847 13,11 L13,7 C13,6.44771525 12.5522847,6 12,6 Z"></path>
        </SvgIcon>
    );
}

function DoedtVedIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8,18.31116 C8,18.31116 8,7.6994554 8,7.6994554 C8,7.08294022 8.89918771,6.94790294 9.28615031,7.21012487 C9.67311291,7.4723468 11.4516711,8.76719634 11.4516711,8.76719634 C11.8765554,9.0734511 12.5490723,8.93374111 12.7418823,8.55079538 C12.7418823,8.55079538 14.4510986,4.39024153 14.4510986,4.39024153 C14.7644653,3.71643747 16,3.99659825 16,4.61374111 C16,4.61374111 16,18.31116 16,18.31116 C16,18.9931385 15.5570888,19.3341277 14.6712663,19.3341277 L9.38746695,19.3341277 C8.46248898,19.3876829 8,19.0466936 8,18.31116 Z M13.1247319,13.4492734 C13.7559145,13.4492734 14.267589,12.9375988 14.267589,12.3064162 C14.267589,11.6752337 13.7559145,11.1635591 13.1247319,11.1635591 C12.4935493,11.1635591 11.9818748,11.6752337 11.9818748,12.3064162 C11.9818748,12.9375988 12.4935493,13.4492734 13.1247319,13.4492734 Z"></path>
        </SvgIcon>
    );
}

function VandIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M12,3 C8.5,3 5,9.33 5,14 C5,17.87 8.13,21 12,21 C15.87,21 19,17.87 19,14 C19,9.33 15.5,3 12,3 Z M13,18 C10,18 8,16.01 8,13 C8,12.45 8.45,12 9,12 C9.55,12 10,12.45 10,13 C10,15.92 12.42,16 13,16 C13.55,16 14,16.45 14,17 C14,17.55 13.55,18 13,18 Z"></path>
        </SvgIcon>
    );
}

function StakkeIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.28571429,16.1428571 C3.02334914,16.1428571 2,15.119508 2,13.8571429 C2,12.5947777 3.02334914,11.5714286 4.28571429,11.5714286 C5.54807943,11.5714286 6.57142857,12.5947777 6.57142857,13.8571429 C6.57142857,15.119508 5.54807943,16.1428571 4.28571429,16.1428571 Z M9.42857143,16.1428571 C8.16620629,16.1428571 7.14285714,15.119508 7.14285714,13.8571429 C7.14285714,12.5947777 8.16620629,11.5714286 9.42857143,11.5714286 C10.6909366,11.5714286 11.7142857,12.5947777 11.7142857,13.8571429 C11.7142857,15.119508 10.6909366,16.1428571 9.42857143,16.1428571 Z M14.5714286,16.1428571 C13.3090634,16.1428571 12.2857143,15.119508 12.2857143,13.8571429 C12.2857143,12.5947777 13.3090634,11.5714286 14.5714286,11.5714286 C15.8337937,11.5714286 16.8571429,12.5947777 16.8571429,13.8571429 C16.8571429,15.119508 15.8337937,16.1428571 14.5714286,16.1428571 Z M19.7142857,16.1428571 C18.4519206,16.1428571 17.4285714,15.119508 17.4285714,13.8571429 C17.4285714,12.5947777 18.4519206,11.5714286 19.7142857,11.5714286 C20.9766509,11.5714286 22,12.5947777 22,13.8571429 C22,15.119508 20.9766509,16.1428571 19.7142857,16.1428571 Z M6.85714286,11.5714286 C5.59477771,11.5714286 4.57142857,10.5480794 4.57142857,9.28571429 C4.57142857,8.02334914 5.59477771,7 6.85714286,7 C8.119508,7 9.14285714,8.02334914 9.14285714,9.28571429 C9.14285714,10.5480794 8.119508,11.5714286 6.85714286,11.5714286 Z M12,11.5714286 C10.7376349,11.5714286 9.71428571,10.5480794 9.71428571,9.28571429 C9.71428571,8.02334914 10.7376349,7 12,7 C13.2623651,7 14.2857143,8.02334914 14.2857143,9.28571429 C14.2857143,10.5480794 13.2623651,11.5714286 12,11.5714286 Z M17.1428571,11.5714286 C15.880492,11.5714286 14.8571429,10.5480794 14.8571429,9.28571429 C14.8571429,8.02334914 15.880492,7 17.1428571,7 C18.4052223,7 19.4285714,8.02334914 19.4285714,9.28571429 C19.4285714,10.5480794 18.4052223,11.5714286 17.1428571,11.5714286 Z"></path>
        </SvgIcon>
    );
}

function BaalstedIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M19.48,12.35 C17.91,8.27 12.32,8.05 13.67,2.12 C13.77,1.68 13.3,1.34 12.92,1.57 C9.29,3.71 6.68,8 8.87,13.62 C9.05,14.08 8.51,14.51 8.12,14.21 C6.31,12.84 6.12,10.87 6.28,9.46 C6.34,8.94 5.66,8.69 5.37,9.12 C4.69,10.16 4,11.84 4,14.37 C4.38,19.97 9.11,21.69 10.81,21.91 C13.24,22.22 15.87,21.77 17.76,20.04 C19.84,18.11 20.6,15.03 19.48,12.35 Z M10.2,17.38 C11.64,17.03 12.38,15.99 12.58,15.07 C12.91,13.64 11.62,12.24 12.49,9.98 C12.82,11.85 15.76,13.02 15.76,15.06 C15.84,17.59 13.1,19.76 10.2,17.38 Z"></path>
        </SvgIcon>
    );
}

function ShelterIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M10.8,3.9 L4.8,8.4 C4.3,8.78 4,9.37 4,10 L4,19 C4,20.1 4.9,21 6,21 L18,21 C19.1,21 20,20.1 20,19 L20,10 C20,9.37 19.7,8.78 19.2,8.4 L13.2,3.9 C12.49,3.37 11.51,3.37 10.8,3.9 Z M7.85,12.2 C8.54,12.2 9.1,12.76 9.1,13.45 C9.1,14.14 8.54,14.7 7.85,14.7 C7.16,14.7 6.6,14.14 6.6,13.45 C6.6,12.76 7.16,12.2 7.85,12.2 Z M18,16.5 L6.52778114,16.5 C6.17672403,16.4973022 6.00119548,16.3306356 6.00119548,16 C6.00119548,15.6693644 6.17672403,15.5026978 6.52778114,15.5 L9.83567205,15.5 L9.83567205,12.5 C9.83567205,12.22 9.94670249,12 10.3147197,12 L16.5282519,12 C17.9740337,12 18,12.9 18,14 L18,16.5 Z"></path>
        </SvgIcon>
    );
}

function UdsigtsIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z M20,4 C21.1,4 22,4.9 22,6 L22,18 C22,19.1 21.1,20 20,20 L4,20 C2.9,20 2,19.1 2,18 L2,6 C2,4.9 2.9,4 4,4 L7.17,4 L8.4,2.65 C8.78,2.24 9.32,2 9.88,2 L14.12,2 C14.68,2 15.22,2.24 15.59,2.65 L16.83,4 L20,4 Z M12,17 C14.76,17 17,14.76 17,12 C17,9.24 14.76,7 12,7 C9.24,7 7,9.24 7,12 C7,14.76 9.24,17 12,17 Z"></path>
        </SvgIcon>
    );
}

function LegepladsIkon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M16.680135,6.85595393 L15.4536462,6.85595393 L15.4536462,14.4718311 L15.8872706,14.4718311 C16.2377817,14.4718311 16.5219271,14.7559764 16.5219271,15.1064875 L16.5219271,16.6931286 C16.5219271,17.0436397 16.2377817,17.327785 15.8872706,17.327785 L8.11272937,17.327785 C7.7622183,17.327785 7.47807294,17.0436397 7.47807294,16.6931286 L7.47807294,15.1064875 C7.47807294,14.7559764 7.7622183,14.4718311 8.11272937,14.4718311 L8.54635377,14.4718311 L8.54635377,6.85595393 L7.31986505,6.85595393 L4.82504233,18.593172 C4.66107279,19.364588 3.90279299,19.8570207 3.13137698,19.6930512 C2.35996097,19.5290816 1.86752831,18.7708018 2.03149784,17.9993858 L4.73652391,5.27323871 C4.77075287,5.11220413 4.8308803,4.96332692 4.91161935,4.83004039 C5.13787071,4.34003487 5.6336057,4 6.20876008,4 L17.7912399,4 C18.3663943,4 18.8621293,4.34003487 19.0883807,4.83004039 C19.1691197,4.96332692 19.2292471,5.11220413 19.2634761,5.27323871 L21.9685022,17.9993858 C22.1324717,18.7708018 21.640039,19.5290816 20.868623,19.6930512 C20.097207,19.8570207 19.3389272,19.364588 19.1749577,18.593172 L16.680135,6.85595393 Z M9.97433074,6.85595393 L9.97433074,14.4718311 L14.0256693,14.4718311 L14.0256693,6.85595393 L9.97433074,6.85595393 Z"></path>
        </SvgIcon>
    );
}

const styles = () => ({
    root: {
        textAlign: 'left',
    },
    textField: {
        width: '100%',
    },
    card: {
        position: 'relative',
        margin: 'auto',
    },
    pointsRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    nonEditTextStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 28,
        width: 28,
        borderRadius: 16,
        marginRight: 10,
    },
});

export class NewPoint extends React.Component {
    constructor(props) {
        super(props);
        // Fields are pre-loaded and note is made editable if it
        // is a new one - e.g. accessed without props
        this.state = {
            screenWidth: window.innerWidth,
            open: false,
            title: ("title" in this.props) ? this.props.title : '',
            from: ("from" in this.props) ? this.props.from : '',
            date: ("date" in this.props) ? this.props.date : '',
            text: ("text" in this.props) ? this.props.text : '',
            radius: ("radius" in this.props) ? this.props.radius : 0,
            images: ("images" in this.props) ? this.props.images : [],
            change: ("title" in this.props) ? false : true,
            point: ("pointType" in this.props) ? this.props.pointType : '',
            historyList: ("historyList" in this.props) ? this.props.historyList : [],
            categories: ("categories" in this.props) ? this.props.categories : [],
            selectedCategory: (("categories" in this.props) && this.props.categories.length > 0) ? getCategoryFromCodeName(this.props.categories[0]) : 'Drift',
            selectedRegistration: (("registrations" in this.props) && this.props.registrations.length > 0) ? this.props.registrations[0] : '',
            year: ("year" in this.props) ? this.props.year : (this.props.chosenWorkEnvironment === 'biotopePlan' ? moment().year() : ''),
            submit: false,
            newNoteState: this.props.title ? false : true,
            saveLoading: false,
            deleteLoading: false,
            disabled: false,
            tempChosenWorkEnvironment: this.props.chosenWorkEnvironment,
            tempSelectedForest: this.props.selectedForest,
            tempSelectedBiotopePlan: this.props.selectedBiotopePlan,
            unSavedData: false,
            showUnsavedWarning: false,
            showDeleteHistItemWarning: false,
            deleteHistItemId: '',
            environment: this.props.environment,
        };
        this.childHandler = this.childHandler.bind(this)
    }

    componentDidMount() {
        if (this.state.newNoteState) {
            this.props.onSetPointEditable(true, 'new')
        }
    }

    componentDidUpdate() {
        // Save navigation
        // disable spinner, navigate back, and show snackbar
        if (this.props.successNote) {
            this.setState({
                change: false,
                saveLoading: false,
                disabled: false
            })

            this.props.onSetNewNoteFinished(true);

            let path = "/"
            // if (this.props.location.state.prevPage === "/Notes") {
            //     path = "/Notes"
            // }

            this.props.history.replace({
                pathname: path,
                state: {
                    prevPage: this.props.location.state.prevPage,
                }
            });
        }

        // Delete navigation
        // disable spinner, navigate back, and show snackbar
        if (this.props.deleteNote) {
            this.setState({
                change: false,
                deleteLoading: false,
                disabled: false
            })

            this.goBackClickHandler();
        }

        // Handle selected forest change when in point
        if (this.state.tempSelectedForest !== this.props.selectedForest && this.props.chosenWorkEnvironment === 'forest') {
            if (this.state.newNoteState) {
                this.setState({ unSavedData: false });
            }
            this.goBackClickHandler()
        }

        // Handle selected biotope plan change
        if (this.state.tempSelectedBiotopePlan !== this.props.selectedBiotopePlan && this.props.chosenWorkEnvironment === 'biotopePlan') {
            if (this.state.newNoteState) {
                this.setState({ unSavedData: false });
            }
            this.goBackClickHandler()
        }

        // Handle environment change when in point
        if (this.state.tempChosenWorkEnvironment !== this.props.chosenWorkEnvironment) {
            if (this.state.newNoteState) {
                this.setState({ unSavedData: false });
            }
            this.goBackClickHandler()
        }
    }

    componentWillUnmount() {
        // Show snackbar if note is saved
        if (this.props.successNote) {
            this.props.onEnqueueSnackbar({
                message: 'Punkt er nu gemt!',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            });
            if (this.props.chosenWorkEnvironment !== 'biotopePlan') {
                const eD = {
                    event: "Punkt gemt",
                    type: "Punkt",
                    reference: this.state.title,
                    forestName: this.props.customerList[this.props.selectedForest].forestName,
                    userId: this.props.currentAuthUser.id,
                    userName: this.props.currentAuthUser.name,
                }
                this.props.onAddEventToEventLog(this.props.selectedForest, eD)
            }
        }

        // Show snackbar if note is deleted
        if (this.props.deleteNote) {
            this.props.onEnqueueSnackbar({
                message: 'Punkt er nu slettet!',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            });
            if (this.props.chosenWorkEnvironment !== 'biotopePlan') {
                const eD = {
                    event: "Punkt slettet",
                    type: "Punkt",
                    reference: this.state.title,
                    forestName: this.props.customerList[this.props.selectedForest].forestName,
                    userId: this.props.currentAuthUser.id,
                    userName: this.props.currentAuthUser.name,
                }
                this.props.onAddEventToEventLog(this.props.selectedForest, eD)
            }
        }

        // If on mobile device close sidebar if note was accessed from map
        if (this.state.screenWidth < 760) {
            if (this.props.location.state.prevPage !== "noteList") {
                this.props.onSidebarOpen(false);
            }
        }

        // Set reducer to initial state
        this.props.onUnmountNote();

        // Make note non-editable again
        // this.props.onSetNoteEditable(false);
        this.props.onSetPointEditable(false, this.props.id)
        this.props.onSetPointEditableLatLng(null)
    }

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    handleClick = () => {
        this.setState({
            open: true,
        });
    };

    goBackClickHandler = () => {
        if (!this.state.unSavedData) {
            // set delete new marker state, if note is not saved
            if (this.state.newNoteState) {
                this.props.onSetDeleteMarker(true, this.props.latlng);
                this.props.onSetNewNoteFinished(true);
            }

            // Choose which route to go back to
            let path = "/"
            // if (this.props.location.state.prevPage === "/Notes") {
            //     path = "/Notes"

            // }

            this.props.history.replace({
                pathname: path,
                state: {
                    prevPage: this.props.location.state.prevPage,
                }
            });
        } else {
            this.setState({ showUnsavedWarning: true })
        }
    }

    ignoreWarningClickHandler = () => {
        // set delete new marker state, if note is not saved
        if (this.state.newNoteState) {
            this.props.onSetDeleteMarker(true, this.props.latlng);
            this.props.onSetNewNoteFinished(true);
        }

        // Choose which route to go back to
        let path = "/"
        // if (this.props.location.state.prevPage === "/Notes") {
        //     path = "/Notes"
        // }

        this.props.history.replace({
            pathname: path,
            state: {
                prevPage: this.props.location.state.prevPage,
            }
        });
    }

    onSelectCatagories = (item) => {
        this.setState({ catagories: item })
    }

    onDeleteClickHandler = () => {
        // Delete note on cloud
        const noteData = {
            id: this.props.id,
            forestId: this.state.environment === 'biotopePlan' ? this.props.planId : this.props.forestId,
            images: this.props.images,
            pointType: true,
        }
        this.props.onDeleteNote(noteData, this.props.chosenWorkEnvironment);

        // Send event to Analytics
        ReactGA.event({
            category: 'Point',
            action: 'Point deleted',
            label: `User: ${this.props.currentAuthUser.name}`
        });

        this.setState({
            deleteLoading: true,
            disabled: true,
        })
    }

    upgradeButtonHandler = () => {
        // Open account handling in main menu
        this.props.onMainMenuOpen(true);
        this.props.onAccountMenuOpen(true);

        // Send event to analytics
        ReactGA.event({
            category: 'Sidebar',
            action: 'Upgrade button clicked',
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    upload = () => {
        // Upload action
        let pointData = null;
        let environment = 'forest';
        // Check which layer point data belongs to
        if (this.props.chosenWorkEnvironment === 'forest') {
            pointData = {
                title: this.state.title,
                text: this.state.text,
                from: this.props.currentAuthUser.name,
                images: this.state.images,
                latlng: this.props.pointEditableLatLng ? this.props.pointEditableLatLng : this.props.latlng,
                id: this.props.id,
                date: moment().format(),
                forestId: this.props.selectedForest,
                pointType: this.state.point,
                radius: this.state.radius,
                environment: environment,
                historyList: this.state.historyList,
                categories: [categories[this.state.selectedCategory].name],
                registrations: [this.state.selectedRegistration],
            }
            // Upload data to forest
            this.props.onSaveNote(pointData, this.props.selectedForest, 'forest', 'sidebar');

        } else if (this.props.chosenWorkEnvironment === 'hunting') {
            environment = 'hunting';
            pointData = {
                title: this.state.title,
                text: this.state.text,
                from: this.props.currentAuthUser.name,
                images: this.state.images,
                latlng: this.props.pointEditableLatLng ? this.props.pointEditableLatLng : this.props.latlng,
                id: this.props.id,
                date: moment().format(),
                forestId: this.props.selectedForest,
                pointType: this.state.point,
                radius: this.state.radius,
                environment: environment,
                historyList: this.state.historyList,
            }
            // Upload data hunting
            this.props.onSaveNote(pointData, this.props.selectedForest, 'hunting', 'sidebar');
        } else if (this.props.chosenWorkEnvironment === 'biotopePlan') {
            environment = 'biotopePlan';
            pointData = {
                title: this.state.title,
                text: this.state.text,
                year: this.state.year,
                from: this.props.currentAuthUser.name,
                images: this.state.images,
                latlng: this.props.pointEditableLatLng ? this.props.pointEditableLatLng : this.props.latlng,
                id: this.props.id,
                date: moment().format(),
                planId: this.props.selectedBiotopePlan,
                pointType: this.state.point,
                environment: environment,
                historyList: this.state.historyList,
            }
            // Upload data biotope plan
            this.props.onSaveNote(pointData, this.props.selectedBiotopePlan, 'biotopePlan', 'sideBar')
        } else {
            console.error("Environment not defined!!!")
        }

        // Send event to Analytics
        ReactGA.event({
            category: 'Point',
            action: 'Point created',
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    changeSaveButton = () => {
        // Upload note to cloud 
        if (this.state.change) {
            // Set submit state
            this.setState({
                submit: true
            })

            // Check if note is incomplete.
            // title, text, and tag
            if (this.state.title !== "" && this.state.point !== "" && (this.props.chosenWorkEnvironment === 'biotopePlan' ? this.state.year !== '' : true)) {
                this.setState({
                    saveLoading: true,
                    disabled: true,
                    submit: false,
                    newNoteState: false,
                })

                this.upload();
            }
        } else {
            // Make point editable
            // this.props.onSetNoteEditable(true);
            this.props.onSetPointEditable(true, this.props.id)
            this.setState({
                change: true
            })
        }
    };

    updateImages = (event) => {
        let files = []
        for (var i = 0; i < event.target.files.length; i++) {
            files[i] = event.target.files.item(i);
        }
        return files;
        // Add new images
        //this.setState({ images: this.state.images.concat(files), unSavedData: true })
    }

    deleteImages = (deleteData, originalData) => {
        let arr = originalData;
        arr = originalData.images.filter(item => {
            return item !== deleteData;
        })
        return arr;
    }

    childHandler(dataFromChild) {
        var arr = this.state.images;

        // Delete selected image
        this.setState({
            images: arr.filter(function (item) {
                return item !== dataFromChild
            })
        })
    }

    handleSelectChange = (event, item) => {
        this.setState({
            [event.target.name]: event.target.value,
            info: item.props.info,
        });
    };

    noteTitle() {
        const { classes } = this.props;
        const { title, submit } = this.state;

        // When note is in editable state 
        if (this.state.change) {
            return (
                <div>
                    <div
                        style={{ display: 'flex', flexDirection: 'row', alignItems: 'top' }}
                    >
                        <IconButton
                            onClick={this.goBackClickHandler}
                            style={{ padding: 3, marginRight: 4, height: 30, width: 30 }}
                        >
                            <GoBackIcon />
                        </IconButton>

                        <Typography
                            variant="h5"
                            gutterBottom
                        >
                            Punkt
                        </Typography >
                    </div>

                    <div>
                        <TextField
                            id="note-title"
                            label="Navn eller nr."
                            className={classes.textField}
                            value={title}
                            onChange={event => this.setState({ title: event.target.value, unSavedData: true })}
                            error={title === "" && submit}
                            disabled={this.state.disabled}
                            margin="normal"
                            required
                        />
                    </div>
                </div>
            );
        }

        // When note is in non-editable state
        return (
            <div
                style={{ display: 'flex', flexDirection: 'row', alignItems: 'top' }}
            >
                <IconButton
                    onClick={this.goBackClickHandler}
                    style={{ padding: 3, marginRight: 4, height: 30, width: 30 }}
                >
                    <GoBackIcon />
                </IconButton>

                <Typography
                    variant="h5"
                    gutterBottom
                >
                    {this.state.title}
                </Typography >
            </div>
        );
    };

    noteDate() {
        // When note is in non-editable state
        if (!this.state.change) {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography
                        variant="caption"
                        noWrap
                        component={'span'}
                        style={{ color: '#747474' }}
                        gutterBottom
                    >
                        {moment(this.state.date).format('DD[-]MM[-]YYYY HH:mm')}
                    </Typography>
                </div>
            )
        }
    }

    noteText() {
        const { classes } = this.props;
        const { text } = this.state;

        // When note is in editable state
        if (this.state.change) {
            return (
                <TextField
                    id="note-text"
                    label="Supplerende info"
                    multiline
                    className={classes.textField}
                    value={text}
                    onChange={event => this.setState({ text: event.target.value, unSavedData: true })}
                    //error={text === "" && submit}
                    disabled={this.state.disabled}
                    margin="normal"
                //required
                />
            );
        }

        // When note is in non-editable state
        return (
            <div>
                <Typography
                    variant="body1"
                    style={{ whiteSpace: 'pre-line', marginBottom: 2 }}
                    gutterBottom
                >
                    {this.state.text}
                </Typography>
            </div>
        );
    };

    noteAuthor() {
        // When note is in non-editable state
        if (!this.state.change) {
            // Get forest name
            let frstName = '';
            if (this.props.customerList) {
                const checkForForestName = this.props.customerList[this.props.forestId];
                frstName = checkForForestName ? checkForForestName.forestName : '';
            }
            return (
                <Typography
                    variant="caption"
                    style={{ color: '#747474' }}
                    gutterBottom
                >
                    {frstName !== '' ? frstName + ", " + this.state.from : this.state.from}
                </Typography>
            )
        }
    }

    noteImages() {
        const { images, change, submit, disabled, tag } = this.state;

        // When note is in non-editable state
        if (change === false && images.length > 0) {
            return (
                <div style={{ paddingTop: 6, paddingBottom: 6 }}>
                    <ImageGridList
                        images={images}
                        change={change}
                    />
                </div>
            );
        }

        // When note is in editable state
        return (
            <div style={{ marginTop: 8 }}>
                <ImageGridList
                    images={images}
                    change={change}
                    action={this.childHandler}
                    disabled={disabled}
                    whenChange={this.updateImages.bind(this)}
                    error={submit && change && images.length < 1 && tag === 'billeder'}
                />
            </div>
        );
    };

    pointsList(freeAccount) {
        const { classes } = this.props;
        const { point, id, change, submit, disabled } = this.state;

        let items = <Select
            value={point}
            onChange={this.handleSelectChange}
            inputProps={{
                name: 'point',
                id: id + 'points-simple',
            }}
        >
            <MenuItem disabled={this.props.configForest.pointsList.stackedLogs === 'disabled'} info={'forest'} value={'Stak'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><StakkeIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Stak</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.other === 'disabled'} info={'forest'} value={'Andet'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><ForestOtherIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Andet</div></MenuItem>
            <Divider />
            <MenuItem disabled={this.props.configForest.pointsList.liveBreedRestArea === 'disabled'} info={'forest'} value={'Leve, yngle, eller rasteområde'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><LeveYngleRasteIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Leve, yngle, eller rasteområde</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.nature === 'disabled'} info={'forest'} value={'Natur'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><NaturIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Natur</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.largeTree === 'disabled'} info={'forest'} value={'Store træer'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><StoreTraerIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Store træer</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.specialTree === 'disabled'} info={'forest'} value={'Særlige træer'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><SaerligeTraerIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Særlige træer</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.deadTree === 'disabled'} info={'forest'} value={'Dødt ved'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><DoedtVedIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Dødt ved</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.water === 'disabled'} info={'forest'} value={'Vand'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><VandIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Vand</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.historicalArea === 'disabled'} info={'forest'} value={'Fortid og kultur'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><FortidKulturIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Fortid og kultur</div></MenuItem>
            <Divider />
            <MenuItem disabled={this.props.configForest.pointsList.vantagePoint === 'disabled'} info={'forest'} value={'Udsigtspost'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><UdsigtsIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Udsigtspost</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.playground === 'disabled'} info={'forest'} value={'Legeplads'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><LegepladsIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Legeplads</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.shelterSite === 'disabled'} info={'forest'} value={'Shelterplads'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><ShelterIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Shelterplads</div></MenuItem>
            <MenuItem disabled={this.props.configForest.pointsList.campfire === 'disabled'} info={'forest'} value={'Bålsted'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><BaalstedIkon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Bålsted</div></MenuItem>
        </Select>
        if (this.props.chosenWorkEnvironment === 'hunting') {
            items = <Select
                value={point}
                onChange={this.handleSelectChange}
                inputProps={{
                    name: 'point',
                    id: id + 'points-simple',
                }}
            >
                <MenuItem disabled={this.props.configHunting.pointsList.groundPost === 'disabled'} info={'hunting'} value={'Jordpost'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HuntingGroundIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Jordpost</div></MenuItem>
                <MenuItem disabled={this.props.configHunting.pointsList.huntingLatter === 'disabled'} info={'hunting'} value={'Jagtstige'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HuntingLatterIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Jagtstige</div></MenuItem>
                <MenuItem disabled={this.props.configHunting.pointsList.huntingTower === 'disabled'} info={'hunting'} value={'Jagttårn'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HuntingTowerIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Jagttårn</div></MenuItem>
                <Divider />
                <MenuItem disabled={this.props.configHunting.pointsList.saltStone === 'disabled'} info={'hunting'} value={'Saltsliksten'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HuntingStoneIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Saltsliksten</div></MenuItem>
                <MenuItem disabled={this.props.configHunting.pointsList.feedingBarrel === 'disabled'} info={'hunting'} value={'Fodertønde'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HuntingBucketIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Fodertønde</div></MenuItem>
                <MenuItem disabled={this.props.configHunting.pointsList.feedingBox === 'disabled'} info={'hunting'} value={'Foderkasse'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HuntingBoxIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Foderkasse</div></MenuItem>
                <Divider />
                <MenuItem disabled={this.props.configHunting.pointsList.camera === 'disabled'} info={'hunting'} value={'Vildtkamera'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><VideocamIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Vildtkamera</div></MenuItem>
                <Divider />
                <MenuItem disabled={this.props.configHunting.pointsList.gatheringPlace === 'disabled'} info={'hunting'} value={'Samlingsplads'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><GroupIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Samlingsplads</div></MenuItem>
                <MenuItem disabled={this.props.configHunting.pointsList.huntingLodge === 'disabled'} info={'hunting'} value={'Jagthytte'}><div className={classes.pointsRow}><div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}><HomeIcon style={{ height: 23, width: 23, color: disabled ? '#717171' : '#2d5c1e' }} /></div>Jagthytte</div></MenuItem>
            </Select>
        } else if (this.props.chosenWorkEnvironment === 'biotopePlan') {
            const biotopeList = getSpeciesListBasedOnCategory('biotopePlan').filter(el => el[1].geometryType === 'point');
            items = <Select
                value={point}
                onChange={this.handleSelectChange}
                inputProps={{
                    name: 'point',
                    id: id + 'points-simple',
                }}
            >
                {biotopeList.map(el => {
                    return (
                        <MenuItem key={"bpItem-" + el[0]} info={'biotopePlan'} value={el[0]}>
                            <div className={classes.pointsRow}>
                                <div className={classes.iconContainer} style={{ border: disabled ? '2px solid #717171' : '2px solid #41842B' }}>
                                    <SvgIcon
                                        fontSize='small'
                                        style={{ color: disabled ? '#717171' : '#2d5c1e' }}
                                    >
                                        <path d={el[1].iconPath}></path>
                                    </SvgIcon>
                                </div>
                                {el[0]}
                            </div>
                        </MenuItem>
                    )
                })};
            </Select>
        }

        // When note is in editable state 
        if (change) {
            return (
                <FormControl
                    margin="normal"
                    fullWidth
                    required
                    error={point === "" && submit}
                    disabled={disabled}
                >
                    <InputLabel htmlFor="select-point">Vælg punkt</InputLabel>

                    {items}
                </FormControl>
            )
        }

        // When note is in non-editable state
        return (
            <div style={{ marginTop: this.props.chosenWorkEnvironment === 'hunting' ? 18 : 0 }}>
                <Typography
                    variant="caption"
                    style={{ color: '#717171' }}
                >
                    Punkt
                </Typography >

                <Typography
                    variant="body1"
                    gutterBottom
                >
                    {this.props.pointType}
                </Typography >
            </div>
        )

    }

    radius() {
        const { classes } = this.props;
        const { radius } = this.state;

        // When inventory is in editable state
        if (this.state.change) {
            return (
                <TextField
                    id={this.state.id + "radius"}
                    label="Skyderadius"
                    className={classes.textField}
                    value={typeof radius === 'number' ? radius.toFixed(0).split('.').join(',') : radius.split('.').join(',')}
                    //type="number"
                    onWheelCapture={e => { e.target.blur() }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">m</InputAdornment>,
                    }}
                    onChange={event => this.setState({ radius: event.target.value, unSavedData: true })}
                    margin="normal"
                    disabled={this.props.configHunting.radius !== 'enabled'}
                />
            );
        }

        // When inventory is in non-editable state
        if (radius !== 0) {
            return (
                <div>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        Skyderadius
                    </Typography >

                    <div className={classes.nonEditTextStyle}>
                        <Typography
                            variant="body1"
                            gutterBottom
                        >
                            {typeof radius === 'number' ? radius.toFixed(0).split('.').join(',') : radius.split('.').join(',')}
                        </Typography >
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ marginBottom: 8 }}
                        >
                            m
                        </Typography >
                    </div>
                </div>
            );
        }
    };

    year = () => {
        const { classes } = this.props;
        const { year, submit } = this.state;

        // When inventory is in editable state
        if (this.state.change) {
            return (
                <TextField
                    id={"year"}
                    label={"Etableringsår"}
                    className={classes.textField}
                    value={year}
                    type="number"
                    onWheelCapture={e => { e.target.blur() }}
                    onChange={event => { this.setState({ year: event.target.value }) }}
                    margin="normal"
                    style={{ marginTop: 16 }}
                    required
                    error={(year === "" && submit)}
                />
            );
        }

        // When inventory is in non-editable state
        if (year !== '') {
            return (
                <div>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        {"Etableringsår"}
                    </Typography >
                    <div className={classes.nonEditTextStyle}>
                        <Typography
                            variant="body1"
                            gutterBottom
                        >
                            {year}
                        </Typography >
                    </div>
                </div>
            );
        }
    }

    noteCancelDelete() {
        // When note is in non-editable state
        if (!this.state.change) {

        }

        // When note is in editable state
        // Set action menu items
        const items = [
            {
                name: "Slet",
                text: "Du er nu ved at slette. Ønsker du at fortsætte? Handlingen kan ikke annulleres.",
                onClickHandler: this.onDeleteClickHandler,
                buttonIcon: true
            },
        ]
        // When note is in editable state
        return (
            <DeleteButton
                items={items}
                deleteLoading={this.state.deleteLoading}
                disabled={this.state.disabled}
            />
        );
    }

    noteChangeSave() {
        // When point is in editfable state
        if (this.state.change) {
            return (
                <div style={{ display: 'flex' }}>
                    <OutlinedButton
                        buttonLabel='Annuller'
                        onPress={this.goBackClickHandler}
                        variant='text'
                        discrete={true}
                    />

                    <ChangeSaveButton
                        change={false}
                        onPress={this.changeSaveButton.bind(this)}
                        saveLoading={this.state.saveLoading}
                        disabled={this.state.disabled}
                    />
                </div>
            );
        }
        // When point is in non-editable state
        let text = "Punkt er skrivebeskyttet. Kan ophæves via hovedmenuen.";
        let showText = false;
        // Forest
        if ((!this.props.forestOwnerAllowChange && this.props.chosenWorkEnvironment === 'forest') || (!this.props.forestOwnerAllowChangeHunting && (this.props.chosenWorkEnvironment === 'hunting' || this.props.chosenWorkEnvironment === 'biotopePlan'))) {
            showText = true;
        }

        // Other layer
        if (this.props.chosenWorkEnvironment !== this.state.environment) {
            text = "Vælg det rette kortlag i kortvælgeren, hvis du ønsker at redigere.";
            showText = true;
        }
        // Restriction according to user
        if (this.props.currentAuthUser.userTags && !this.props.currentAuthUser.userTags.some(tag => ["Admin", "Skovfoged", "Skovejer"].includes(tag))) {
            text = "Punkt er skrivebeskyttet.";
            showText = true;
        }
        if (this.props.configUnderManagement !== '' && this.props.chosenWorkEnvironment === 'forest' && this.props.environment === 'forest') {
            text = this.props.configUnderManagement;
            showText = true;
        }
        // Biotope plan
        if (this.props.biotopePlansUser[this.props.selectedBiotopePlan] && this.props.biotopePlansUser[this.props.selectedBiotopePlan].locked) {
            text = "Tiltag kan ikke ændres, da biotopplanen er låst."
            showText = true;
        }
        return (
            <div>
                <ChangeSaveButton
                    change={true}
                    onPress={this.changeSaveButton.bind(this)}
                    saveLoading={this.state.saveLoading}
                    disabled={this.state.disabled || showText ||
                        (this.props.selectedForest !== this.props.forestId && (this.props.chosenWorkEnvironment === 'forest' || this.props.chosenWorkEnvironment === 'hunting')) ||
                        (this.props.selectedBiotopePlan !== this.props.planId && this.props.chosenWorkEnvironment === 'biotopePlan') ||
                        (this.state.environment !== this.props.chosenWorkEnvironment) ||
                        (!this.props.forestOwnerAllowChange && this.state.environment === 'forest') ||
                        (!this.props.forestOwnerAllowChangeHunting && this.state.environment === 'hunting')
                    }
                />
                {showText &&
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ marginLeft: 10, marginRight: 10, marginBottom: 6 }}
                        >
                            {text}
                        </Typography >
                    </div>}
            </div>
        );
    }

    onAddHistoryItem = () => {
        // Send event to Analytics
        ReactGA.event({
            category: 'Point',
            action: 'History item added',
            label: `User: ${this.props.currentAuthUser.name}`
        });

        // Generate id
        const id = moment().format() + "," + Math.floor(Math.random() * 1000).toString();
        const updatedHistArray = { ...this.state.historyList };
        updatedHistArray[id] = {
            id: id,
            from: this.props.currentAuthUser.name,
            date: new Date(moment().format()).toString(),
            note: '',
            images: [],
            creationDate: new Date(moment().format()).toString(),
        }
        this.setState({ historyList: updatedHistArray, unSavedData: true });
    }

    onDeleteHistoryItem = (id) => {
        this.setState({ deleteHistItemId: id, showDeleteHistItemWarning: true })
    }

    histListinputChangedHandler = (value, inputIdentifier, type) => {
        const updatedHistArray = {
            ...this.state.historyList
        };
        const updatedHistElement = {
            ...updatedHistArray[inputIdentifier]
        };
        if (type === "date") {
            updatedHistElement.date = value.toString();
        } else if (type === "note") {
            updatedHistElement.note = value;
        } else if (type === "addImage") {
            const imgs = this.updateImages(value);
            updatedHistElement.images = updatedHistElement.images ? updatedHistElement.images.concat(imgs) : imgs;
        } else if (type === "deleteImage") {
            const imgs = this.deleteImages(value, updatedHistElement);
            updatedHistElement.images = imgs;
        }
        updatedHistArray[inputIdentifier] = updatedHistElement;
        this.setState({ historyList: updatedHistArray, unSavedData: true });
    }

    ignoreDeleteHistItemWarning = () => {
        // Send event to Analytics
        ReactGA.event({
            category: 'Point',
            action: 'History item deleted',
            label: `User: ${this.props.currentAuthUser.name}`
        });

        const updatedHistArray = { ...this.state.historyList };
        delete updatedHistArray[this.state.deleteHistItemId];
        this.setState({ historyList: updatedHistArray, unSavedData: true, deleteHistItemId: '', showDeleteHistItemWarning: false });
    }

    renderTips() {
        if (this.state.change && !this.state.newNoteState) {
            return (
                <div style={{ marginLeft: 8, marginRight: 8, marginTop: 12, marginBottom: 8 }}>
                    <Typography variant="body1" >
                        Tip
                    </Typography >

                    <div style={{ display: 'flex' }}>
                        <Typography variant="body2" style={{ color: '#6A6A6A', marginLeft: 4, marginRight: 8 }} >
                            •
                        </Typography >

                        <Typography variant="body2" style={{ color: '#6A6A6A' }} >
                            Punkter i kortet kan flyttes, ved at trække i dem med musen
                        </Typography >
                    </div>
                </div>
            )
        }
    }

    onSelectCategories = (item) => {
        if (item === 'upgrade') {
            // Open account handling in main menu
            this.props.onMainMenuOpen(true);
            this.props.onAccountMenuOpen(true);
        } else {
            this.setState({ selectedCategory: item, unSavedData: true })
        }
    }

    onSelectRegistrations = (item) => {
        this.setState({ selectedRegistration: item, unSavedData: true })
    }

    render() {
        const { classes } = this.props;
        const { title, point, change, newNoteState } = this.state;

        // Set history list lables
        let histListTitle = 'Historik';
        let histListAddButtonLabel = 'Tilføj historik';
        let histListNoChangeTitle = 'Historik';
        if (point === "Jordpost" || point === "Jagtstige" || point === "Jagttårn") {
            histListTitle = "Nedlægninger";
            histListAddButtonLabel = "Tilføj nedlægning"
            histListNoChangeTitle = "Nedlægninger";
        } else if (point === "Fodertønde" || point === "Foderkasse") {
            histListTitle = "Opfyldninger";
            histListAddButtonLabel = "Tilføj opfyldning"
            histListNoChangeTitle = "Opfyldninger";
        } else if (point === "Saltsliksten") {
            histListTitle = "Opsætninger";
            histListAddButtonLabel = "Tilføj opsætning"
            histListNoChangeTitle = "Opsætninger";
        }

        const freeAccount = this.props.chosenWorkEnvironment === 'forest' && this.props.configForest.categoryExtended !== 'enabled';

        return (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <CardContent>
                        {this.noteTitle()}
                        {this.noteDate()}
                        {this.noteText()}
                        {this.noteAuthor()}
                        {this.props.chosenWorkEnvironment === 'biotopePlan' && this.year()}

                        {this.props.chosenWorkEnvironment === 'forest' && this.props.configForest.category !== 'hidden' && <div>
                            <div style={{ marginTop: !this.state.change ? 18 : 0 }}>
                                <DropDownMenu
                                    topic='categories'
                                    freeAccount={freeAccount}
                                    upgradeBox='hidden'
                                    content={categories}
                                    editable={this.state.change}
                                    onPress={(item) => this.onSelectCategories(item)}
                                    selected={this.state.selectedCategory}
                                    inputLabel='Anvendelse'
                                    label='Anvendelse'
                                    type={'Point'}
                                    required={true}
                                />
                            </div>

                            {(this.props.configForest.registration !== 'hidden' && (categories[this.state.selectedCategory].nøglebiotop || categories[this.state.selectedCategory].nøgleelement || categories[this.state.selectedCategory].beskyttetNatur)) && <DropDownMenu
                                topic='registrations'
                                categoryType={this.state.selectedCategory}
                                // content={registrations}
                                editable={this.state.change}
                                onPress={(item) => this.onSelectRegistrations(item)}
                                selected={this.state.selectedRegistration}
                                inputLabel='Registrering'
                                label='Registrering'
                                type={'Point'}
                                required={false}
                            />}
                        </div>}

                        {this.pointsList(freeAccount)}

                        {(point === "Jordpost" || point === "Jagtstige" || point === "Jagttårn") && this.radius()}

                        {this.renderTips()}

                        {((point !== "" && ((this.props.chosenWorkEnvironment === 'forest' && this.props.configForest.history !== 'hidden') || this.props.chosenWorkEnvironment === 'biotopePlan')) || (point !== "" && this.props.chosenWorkEnvironment === 'hunting' && this.props.configHunting.history !== 'hidden' && point !== "Jagthytte" && point !== "Samlingsplads")) && <HistoryList
                            items={this.state.historyList}
                            type={histListTitle}
                            variant={"hunting"}
                            notChangeTitle={histListNoChangeTitle}
                            change={this.state.change}
                            addButtonLabel={histListAddButtonLabel}
                            addItem={this.onAddHistoryItem}
                            onDeleteHandler={this.onDeleteHistoryItem}
                            inputChangedHandler={this.histListinputChangedHandler}
                            imageActionHandler={this.childHandler}
                            updateImages={this.updateImages}
                            networkStatus={this.props.networkStatus}
                            disableAddButton={((this.props.chosenWorkEnvironment === 'hunting' && this.props.configHunting.history !== 'enabled') ||
                                (this.props.chosenWorkEnvironment === 'forest' && this.props.configForest.history !== 'enabled'))}
                            freeLabel={null}
                        />}
                        {(this.state.change && this.props.chosenWorkEnvironment === "forest" && this.props.configForest.upgradeMenu.title !== "") && <div style={{ marginTop: 24 }}>
                            <UpgradeMenu
                                title={this.props.configForest.upgradeMenu.title}
                                content={this.props.configForest.upgradeMenu.text}
                                cta='Opgrader'
                                onPress={() => this.upgradeButtonHandler()}
                            />
                        </div>}
                        {(this.state.change && this.props.chosenWorkEnvironment === "hunting" && this.props.configHunting.upgradeMenu.title !== "") && <div style={{ marginTop: 24 }}>
                            <UpgradeMenu
                                title={this.props.configHunting.upgradeMenu.title}
                                content={this.props.configHunting.upgradeMenu.text}
                                cta='Opgrader'
                                onPress={() => this.upgradeButtonHandler()}
                            />
                        </div>}
                    </CardContent>

                    <CardActions>
                        {this.noteChangeSave()}
                        {!newNoteState && change && title !== "" && this.noteCancelDelete()}

                        {/* <div style={{ display: 'flex', flexDirection: "column" }}>
                            {this.renderTips()}

                            <div style={{ display: 'flex', flexDirection: "row" }}>
                                {!newNoteState && change && title !== "" && this.noteCancelDelete()}
                                {this.noteChangeSave()}
                            </div>
                        </div> */}
                    </CardActions>
                </Card>

                <Dialog open={this.state.showUnsavedWarning}>
                    <DialogTitle>
                        OBS
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText>
                            Der findes ændringer, som endnu ikke er gemte.
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
                            <OutlinedButton
                                buttonLabel='Tilbage'
                                onPress={() => this.setState({ showUnsavedWarning: false })}
                                variant='text'
                                discrete={true}
                            />

                            <OutlinedButton
                                buttonLabel='Ændringer skal ikke gemmes'
                                buttonIcon={<IconChevronRight />}
                                iconLeft={false}
                                onPress={this.ignoreWarningClickHandler}
                                color='primary'
                            />
                        </div>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.showDeleteHistItemWarning}>
                    <DialogTitle>
                        OBS
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Du er ved at fjerne noget historik. Ønsker du at fortsætte?
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
                            <OutlinedButton
                                buttonLabel='Tilbage'
                                onPress={() => this.setState({ showDeleteHistItemWarning: false })}
                                variant='text'
                                discrete={true}
                            />
                            <OutlinedButton
                                buttonLabel='Fjern'
                                buttonIcon={<IconChevronRight />}
                                iconLeft={false}
                                onPress={this.ignoreDeleteHistItemWarning}
                                color='primary'
                            />
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        networkStatus: state.layout.networkStatus,
        successNote: state.notes.successNote,
        deleteNote: state.notes.deleteNote,
        currentAuthUser: state.user.currentAuthUser,
        onboardingActive: state.onboarding.onboardingActive,
        onboardingState: state.onboarding.onboardingState,
        selectedForest: state.customer.currentlySelectedForestId,
        selectedBiotopePlan: state.biotopePlans.currentlySelectedBiotopePlanId,
        sidebar: state.layout.sidebarOpen,
        customerList: state.customer.customerList,
        loadingSendTodo: state.user.loadingSendTodo,
        errorSendTodo: state.user.errorSendTodo,
        sendTodoSuccess: state.user.sendTodoSuccess,
        chosenWorkEnvironment: state.layout.chosenWorkEnvironment,
        forestOwnerAllowChange: state.maps.forestOwnerAllowChange,
        forestOwnerAllowChangeHunting: state.hunting.forestOwnerAllowChange,
        pointEditableLatLng: state.notes.pointEditableLatLng,
        huntingActive: state.account.huntingActive,
        huntingPlusActive: state.account.huntingPlusActive,
        operationActive: state.account.operationActive,
        operationPlusActive: state.account.operationPlusActive,
        configHunting: state.appConfig.huntingSidebar.point,
        configForest: state.appConfig.inventorySidebar.point,
        configUnderManagement: state.appConfig.inventorySidebar.underManagementText,
        biotopePlansUser: state.biotopePlans.biotopePlansUser,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onSaveNote: (noteData, forestId, layerType) => dispatch(actions.saveNote(noteData, forestId, layerType)),
        onEnqueueSnackbar: (message, options) => dispatch(actions.enqueueSnackbar(message, options)),
        onUnmountNote: () => dispatch(actions.unmountNote()),
        onDeleteNote: (noteData, envType) => dispatch(actions.deleteNote(noteData, envType)),
        onSetDeleteMarker: (s, latlng) => dispatch(actions.setDeleteMarker(s, latlng)),
        onSetNewNoteFinished: (s) => dispatch(actions.setNewNoteFinished(s)),
        onSetNoteEditable: (s) => dispatch(actions.setNoteEditable(s)),
        onSetPointEditable: (s, id) => dispatch(actions.setPointEditable(s, id)),
        onSetPointEditableLatLng: (latlng) => dispatch(actions.setPointEditableLatLng(latlng)),
        onSetOnboardingState: (s) => dispatch(actions.setOnboardingState(s)),
        onSidebarOpen: (state) => dispatch(actions.sidebarOpen(state)),
        onAddEventToEventLog: (forestId, data) => dispatch(actions.addEventToEventLog(forestId, data)),
        onSendTodoEmail: (todoData) => dispatch(actions.sendTodoEmail(todoData)),
        onUserResetError: () => dispatch(actions.userResetError()),
        onSetRedrawHuntingPoints: (s) => dispatch(actions.setRedrawHuntingPoints(s)),
        onMainMenuOpen: (state) => dispatch(actions.mainMenuOpen(state)),
        onAccountMenuOpen: (state) => dispatch(actions.accountMenuOpen(state)),
    };
}

NewPoint.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NewPoint)));